import { ERROR_TEXT_GEO, ERROR_TEXT_GEO_DEFAULT } from 'constants/messages'

import { Store, FmdGood, Map as MapIcon } from '@mui/icons-material'
import { yandexMapRouteSetting } from 'feature/addresses/redux/addressCreateSelector'
import { TService } from 'feature/serviceCenters/types'
import { getUserGeolocation } from 'feature/YandexMap/lib/getUserGeolocation'
import { useSetNotice } from 'hooks/useSetNotice'
import { useState } from 'react'
import { useActions, useAppSelector } from 'store/hooks'
import { Button } from 'ui'
import { LoaderInCentalPosition } from 'widget'
import { InformationBlock } from 'widget/InformationBlock/InformationBlock'
import { Severity } from 'widget/Notifications'

import style from './ServiceDetailAddress.module.scss'

type TServiceDetailAddress = {
  service: TService
}

// адрес и проложение маршрута на детальной странице сц
export function ServiceDetailAddress({ service }: TServiceDetailAddress) {
  const [isDisabled, setIsDisabled] = useState<boolean>(false)
  const { setUserGeo, setRouteSetting } = useActions()
  const { isLoading } = useAppSelector(yandexMapRouteSetting)

  const setNotice = useSetNotice()

  const getUserGeoError = (err: GeolocationPositionError) => {
    const errorText = err.code === 1 ? ERROR_TEXT_GEO : ERROR_TEXT_GEO_DEFAULT
    setNotice(errorText, Severity.error)
    setUserGeo({ address: null })
  }

  const getUserGeoSuccess = (position: GeolocationPosition | undefined) => {
    if (!position) return

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })

    if (service?.address) {
      setRouteSetting({
        from: [position.coords.latitude, position.coords.longitude],
        to: service.address,
        isLoading: true,
      })
    }
  }
  const getUserGeoHandler = () => {
    setIsDisabled(true)
    getUserGeolocation({
      successFunction: getUserGeoSuccess,
      errorFunction: getUserGeoError,
    })
  }

  return (
    <InformationBlock title='Адрес'>
      <span className='default-text'>
        <Store color='primary' />
        {service.name}
      </span>
      <span className='default-text'>
        <FmdGood color='primary' />
        {service.address}
      </span>
      <Button
        variant='text'
        startIcon={<MapIcon color='primary' />}
        onClick={getUserGeoHandler}
        disabled={isDisabled}
        data-testid='sc-route-btn'
      >
        {isLoading && <LoaderInCentalPosition className={style.btnLoader} />}
        Проложить маршрут
      </Button>
    </InformationBlock>
  )
}
